// ============================================================================
// Calendar (ICS) subscription hooks — the TRAINER's own feed URL.
// ----------------------------------------------------------------------------
// `useCalendarSubscription` get-or-creates the stable, token-gated feed URL the
// trainer pastes into Google/Apple/Outlook. `useRotateCalendarSubscription`
// mints a fresh token (revoking any leaked link) and writes the new URL straight
// into the cache so the displayed URL updates without a refetch.
// ============================================================================
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { calendarApi, qk } from "../api";
import type { CalendarSubscription } from "../api";

export function useCalendarSubscription() {
  return useQuery({
    queryKey: qk.calendar.subscription,
    queryFn: ({ signal }) => calendarApi.subscription(signal),
    // The feed URL is stable until rotated; no need to refetch aggressively.
    staleTime: 5 * 60 * 1000,
  });
}

export function useRotateCalendarSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => calendarApi.rotate(),
    onSuccess: (next: CalendarSubscription) => {
      qc.setQueryData(qk.calendar.subscription, next);
    },
  });
}
